const toNumber = (value) => {
  if (value === null || value === undefined || value === '' || typeof value === 'boolean') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

// Each row is a sample; value arrays or value/value2/... fields are series.
export function getChartSeries(chartData) {
  const points = Array.isArray(chartData) ? chartData.filter((point) => point && typeof point === 'object' && !Array.isArray(point)) : [];
  const keys = new Set();
  points.forEach((point) => {
    if (Array.isArray(point.value)) {
      point.value.forEach((_, index) => keys.add(index === 0 ? 'value' : `value${index + 1}`));
    } else {
      Object.keys(point)
        .filter((key) => /^value\d*$/.test(key))
        .forEach((key) => keys.add(key));
    }
  });
  const series = [...keys].sort((a, b) => (a === 'value' ? 0 : Number(a.slice(5))) - (b === 'value' ? 0 : Number(b.slice(5))));
  const data = points
    .map((point) => {
      const row = { ...point };
      series.forEach((key) => {
        const index = key === 'value' ? 0 : Number(key.slice(5)) - 1;
        row[key] = toNumber(Array.isArray(point.value) ? point.value[index] : point[key]);
      });
      return row;
    })
    .filter((point) => series.some((key) => point[key] !== null));
  return { series: series.length ? series : ['value'], data: data.length ? data : [{ value: 0 }] };
}
